<template>
    <!--<div class="grid-wrapper">
        <div class="content department-info settings-container">
            <div class="heading">
                <button
                        class="atto-btn back-to"
                        @click="goBack"
                >
                    <i class="atto atto-ldir-arrow-b"/>
                </button>
                <h2 class="page-title">
                    {{ department.name }}
                </h2>
                <button
                        class="atto-btn edit-name"
                        @click="editDepartment(department)"
                >
                    <i class="atto atto-edit-btn"/>
                </button>
            </div>
            <div class="list-container">
                <div class="table-heading">
                    <span class="heading-label name">{{ label.get('name') }}</span>
                    <span class="heading-label role">{{ label.get('role') }}</span>
                </div>

                <div class="role-heading">
                    <h4 class="subtitle">{{label.get('managers')}}</h4>
                </div>
                <div class="button-holder">
                    <button
                            class="invite"
                            @click="addNewManagers"
                    >
                        <i class="atto atto-add-more"/>
                        {{ label.get('department_add_managers') }}
                    </button>
                </div>

                <ul class="team-members">
                    <li
                            v-if="!departmentManagers.length"
                            class="no-members"
                    >
                        <div
                                v-if="!departmentManagers.length"
                                class="no-time-entry"
                        >
                        </div>
                    </li>

                    <li
                            v-for="(member, id) in departmentManagers"
                            :key="id"
                    >
                        <div class="pic-wrap">
              <span
                      v-if="!member.avatar"
                      class="initials"
              >{{ member.initials }}</span>
                            <img
                                    v-if="member.avatar"
                                    :src="member.avatar"
                                    width="40"
                                    height="40"
                                    class="member-pic"
                            >
                        </div>
                        <div class="member-wrap">
                            <h4 class="member-name">
                                {{ member.name }}
                            </h4>
                        </div>
                        <div class="dep-wrap">
              <span class="detailed-label">
                {{ getRoleLabel(member) }}
              </span>
                        </div>
                        <div class="switch-options delete">
                            <button
                                    class="delete-log"
                                    @click="deleteManager(member)"
                            >
                                <i class="atto atto-delete"/>
                            </button>
                        </div>
                    </li>
                </ul>


                <div class="role-heading members">
                    <h4 class="subtitle">{{label.get('members')}}</h4>
                </div>
                <div class="button-holder">
                    <button
                            class="invite"
                            @click="addNewMembers"
                    >
                        <i class="atto atto-add-more"/>
                        {{ label.get('department_add_members') }}
                    </button>
                </div>

                <ul class="team-members" v-bind:class="{ 'no-members' : departmentMembers.length }">
                    <li
                            v-if="!departmentMembers.length"
                            class="no-members"
                    >
                        <div
                                v-if="!departmentMembers.length"
                                class="no-time-entry"
                        >
                           &lt;!&ndash; <div class="entry-wrap">
                                <i class="atto-icon"/>
                                <h4 class="subtitle">
                                    {{ label.get('no_members_available') }}
                                </h4>
                                <p
                                        style="padding: 0;"
                                        v-html="label.get('department_you_havent_added_any_team_member')"
                                />
                                <button
                                        class="atto-btn add-entry"
                                        @click="addNewMembers"
                                >
                                    {{ label.get('department_add_members') }}
                                </button>
                            </div>&ndash;&gt;
                        </div>
                    </li>

                    <li
                            v-for="(member, id) in departmentMembers"
                            :key="id"
                    >
                        <div class="pic-wrap">
              <span
                      v-if="!member.avatar"
                      class="initials"
              >{{ member.initials }}</span>
                            <img
                                    v-if="member.avatar"
                                    :src="member.avatar"
                                    width="40"
                                    height="40"
                                    class="member-pic"
                            >
                        </div>
                        <div class="member-wrap">
                            <h4 class="member-name">
                                {{ member.name }}
                            </h4>
                        </div>
                        <div class="dep-wrap">
              <span class="detailed-label">
                {{ getRoleLabel(member) }}
              </span>
                        </div>
                        <div class="switch-options">
                            <button
                                    class="switch-department"
                                    @click="toggleSwitchModal(member)"
                            >
                                {{ label.get('department_switch_members') }}
                                <i class="switch-logo"/>
                            </button>
                        </div>
                    </li>
                </ul>


            </div>
        </div>
        <add-members
                v-if="addMembers"
                :department="department"
        />
        <add-managers
                v-if="addManagers"
                :department="department"
        />
        <edit-department
                v-if="editName"
                :department="department"
        />
        <switch-department
                v-if="switchDepartment"
                :member="selectedMember"
        />
        <delete-manager-from-department-component
                v-if="showDeleteManager"
                :manager="selectedManager"
                :department="department"
        />
    </div>-->


  <div>
    <div class="centered-column">
      <div class="container-header">
        <button
            class="back-btn"
            @click="goBack"
        >
          <i class="atto atto-ldir-arrow-b"/>
        </button>
        <h3>{{ department.name }}</h3>
      </div>
      <div class="white-card" v-if="!loading">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('department_managers')}}</label>
           <!-- <i class="atto info-icon"
               id="tooltip-department-managers">
            </i>
            <b-tooltip
                target="tooltip-department-managers"
                custom-class="info-tooltip"
                placement="bottom" >
              <label>{{ label.get('department_managers') }}</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
            </b-tooltip>-->
          </div>
          <button
              class="add-new-btn"
              @click="addNewManagers"
              v-if="departmentManagers.length"
          >
            <i class="atto atto-add-more" />
            {{ label.get('add_managers_to_this_department') }}
          </button>
        </div>
        <div class="list-container" v-if="departmentManagers.length">
          <div class="table-heading">
            <div class="label-holder">
              <span class="heading-label name">{{ label.get('name') }}</span>
              <span class="heading-label role">{{ label.get('role') }}</span>
            </div>
          </div>
          <ul class="team-members">
            <li
                v-for="(member, id) in departmentManagers"
                :key="id"
            >
              <div class="member-info">
                <div class="pic-wrap">
                <span
                    v-if="!member.avatar"
                    class="initials"
                >{{ member.initials }}</span>
                  <img
                      v-if="member.avatar"
                      :src="member.avatar"
                      width="40"
                      height="40"
                      class="member-pic"
                  >
                </div>
                <div class="member-wrap">
                  <h4 class="member-name">
                    {{ member.name }}
                  </h4>
                </div>
                <div class="dep-wrap">
                <span class="detailed-label">
                  {{ getRoleLabel(member) }}
                </span>
                </div>
              </div>
              <div class="switch-options delete">
               <!-- <button
                    class="delete-log"
                    @click="deleteManager(member)"
                >
                  <i class="atto atto-delete"/>
                </button>-->
              </div>
            </li>
          </ul>
        </div>
        <div
            v-if="!departmentManagers.length"
            class="no-items"
        >
          <div class="item-wrap">
            <i class="no-managers" />
            <button
                class="atto-btn add-entry add-item"
                @click="addNewManagers"
            >
              {{label.get('assign_a_manager')}}
            </button>
            <p>
              {{label.get('add_team_managers_department')}}
            </p>
          </div>
        </div>
      </div>
      <div class="white-card" v-if="!loading">
        <div class="white-card-header">
          <div class="title-wrap">
            <label class="title-label">{{label.get('members')}}</label>
           <!-- <i class="atto info-icon"
               id="tooltip-members"></i>
            <b-tooltip
                target="tooltip-members"
                custom-class="info-tooltip"
                placement="bottom" >
              <label>{{label.get('members')}}</label>
              <p>Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et
                dolore magna aliqua. Ut enim ad minim veniam, quis.</p>
            </b-tooltip>-->
          </div>
          <button
              class="add-new-btn"
              @click="addNewMembers"
              v-if="departmentMembers.length"
          >
            <i class="atto atto-add-more" />
            {{ label.get('add_members_to_this_department') }}
          </button>
        </div>
        <div class="list-container" v-if="departmentMembers.length">
          <div class="table-heading">
            <div class="label-holder">
              <span class="heading-label name">{{ label.get('name') }}</span>
              <span class="heading-label role">{{ label.get('role') }}</span>
            </div>
          </div>
          <ul class="team-members" v-bind:class="{ 'no-members' : departmentMembers.length }">
          <li
              v-for="(member, id) in departmentMembers"
              :key="id"
          >
            <div class="member-info">
              <div class="pic-wrap">
              <span
                  v-if="!member.avatar"
                  class="initials"
              >{{ member.initials }}</span>
                <img
                    v-if="member.avatar"
                    :src="member.avatar"
                    width="36"
                    height="36"
                    class="member-pic"
                >
              </div>
              <div class="member-wrap">
                <h4 class="member-name">
                  {{ member.name }}
                </h4>
              </div>
              <div class="dep-wrap">
              <span class="detailed-label">
                {{ getRoleLabel(member) }}
              </span>
              </div>
            </div>


            <div class="switch-options">
              <button
                  class="switch-department"
                  @click="toggleSwitchModal(member)"
              >
                <i class="switch-logo atto-rdir-arrow-b atto"/>
                {{ label.get('department_switch_members') }}
              </button>
            </div>
          </li>
        </ul>
        </div>
        <div
            v-if="!departmentMembers.length"
            class="no-items"
        >
          <div class="item-wrap">
            <i class="no-members" />
            <button
                class="atto-btn add-entry add-item"
                @click="addNewMembers"
            >
              {{label.get('department_add_members')}}
            </button>
            <p>
              {{label.get('add_team_members_department')}}
            </p>
          </div>
        </div>
      </div>
    </div>
    <add-members
        v-if="addMembers"
        :department="department"
    />
    <add-managers
        v-if="addManagers"
        :department="department"
    />
    <edit-department
        v-if="editName"
        :department="department"
    />
    <switch-department
        v-if="switchDepartment"
        :member="selectedMember"
    />
    <delete-manager-from-department-component
        v-if="showDeleteManager"
        :manager="selectedManager"
        :department="department"
    />
  </div>
</template>

<script>
    import DepartmentService from '../services/DepartmentService';
    import AddMembers from './AddMembersToDepartmentComponent';
    import SwitchDepartment from './SwitchDepartmentComponent';
    import EditDepartment from '../components/EditDepartmentComponent';
    import AddManagers from "./AddManagersToDepartmentComponent";
    import DeleteManagerFromDepartmentComponent from "./DeleteManagerFromDepartmentComponent";

    export default {
        name: "ViewDepartmentComponent",
        components: {
            DeleteManagerFromDepartmentComponent,
            SwitchDepartment,
            AddMembers,
            EditDepartment,
            AddManagers
        },
        data() {
            return {
                addMembers: false,
                departmentMembers: [],
                departmentManagers: [],
                editName: false,
                department: this.getDepartmentById(this.$route.params.did),
                switchDepartment: false,
                selectedMember: null,
                selectedManager: null,
                addManagers: false,
                showDeleteManager: false,
                loading: true
            }
        },
        created() {
            this.getMemberList(this.department.id);
        },
        mounted() {
            this.$root.$on('hideAddMembersToDep', this.hideAddMembersToDep);
            this.$root.$on('hideAddManagersToDep', this.hideAddManagersToDep);
            this.$root.$on('hideDeleteManager', this.hideDeleteManager);
            this.$root.$on('hideEditDepartment', this.hideEditDepartment);
            this.$root.$on('hideSwitchDepartmentModal', this.hideSwitchDepartment);
        },
        methods: {
            getDepartmentById(id) {
                const department = this.$store.state.companyDepartments.find((item) => {
                    return item.id === parseInt(id)
                });
                if (department === undefined) {
                    this.$router.push({path: '/404'});
                }
                return department;
            },
            addNewMembers() {
                this.addMembers = true;
            },
            addNewManagers() {
                this.addManagers = true;
            },
            getMemberList(departmentId) {
                this.departmentMembers = this.getMembersFromStore();
                DepartmentService.showDepartment(departmentId).then((result) => {
                    this.departmentMembers = result.members.map((item) => {
                        const member = this.$store.state.members.find((i) => {
                            return i.id === item.id;
                        });
                        if (member !== null) {
                            item.initials = member.initials;
                            item.avatar = member.avatar;
                            item.department_id = member.department_id;
                        }
                        return item;
                    });

                    this.departmentManagers = result.managers.map((item) => {
                        const member = this.$store.state.members.find((i) => {
                            return i.id === item.id;
                        });
                        if (member !== null) {
                            item.initials = member.initials;
                            item.avatar = member.avatar;
                            item.department_id = member.department_id;
                        }
                        return item;
                    });
                    this.loading = false;
                }).catch((error) => {
                    this.loading = false;
                    console.log(error)
                });
            },
            getMembersFromStore() {
                return this.$store.state.members.filter((item) => {
                    if (item.department_id === this.department.id) {
                        return {
                            email: item.email,
                            id: item.id,
                            label: "",
                            name: item.name,
                            role_id: item.role_id,
                            type: "member",
                            initials: item.initials,
                            avatar: item.avatar,
                            department_id: item.department_id
                        };
                    }
                });
            },
            getRoleLabel(member) {
                if (member.id === this.$store.state.company.user_id) {
                    return this.label.get('owner');
                }
                if (member.role_id === 1) {
                    return this.label.get('admin');
                }
                if (member.role_id === 2) {
                    return this.label.get('manager');
                }
                if (member.role_id === 3) {
                    return this.label.get('employee');
                }
                return this.label.get('employee');
            },
            goBack() {
                this.$router.go(-1);
            },
            editDepartment(department) {
                this.editName = true;
            },
            hideEditDepartment() {
                this.editName = false;
            },
            hideAddMembersToDep(success) {
                this.addMembers = false;
                if (success) {
                    this.departmentMembers = this.getMembersFromStore();
                }
            },
            hideAddManagersToDep(data) {
                this.addManagers = false;
                if (data) {
                    this.departmentManagers.push(...data);
                }
            },
            toggleSwitchModal(member){
                this.selectedMember = member;
                this.switchDepartment = true;
            },
            hideSwitchDepartment(data){
                this.switchDepartment = false;
                this.selectedMember = null;
                if(data) {
                    const index = this.departmentMembers.indexOf(data.member);
                    this.departmentMembers.splice(index, 1);
                    this.$store.state.members.forEach((item) => {
                        if(item.id === data.member.id) {
                            item.department = data.department !== null ? data.department : null;
                            item.department_id = data.department !== null ? data.department.id : null;
                        }
                    });
                }
            },
            deleteManager(manager) {
                this.selectedManager = manager;
                this.showDeleteManager = true;
            },
            hideDeleteManager(deleted) {
                this.showDeleteManager = false;
                if (deleted) {
                    const index = this.departmentManagers.indexOf(this.selectedManager);
                    this.departmentManagers.splice(index, 1);
                }
                this.selectedManager = null;
            }
        },
        beforeDestroy() {
          this.$root.$off('hideAddMembersToDep');
          this.$root.$off('hideAddManagersToDep');
          this.$root.$off('hideDeleteManager');
          this.$root.$off('hideEditDepartment');
          this.$root.$off('hideSwitchDepartmentModal');
        }
    }
</script>

<style lang="scss" scoped>

  .container-wrap .container-header{
    padding: 10px 8px;
    justify-content: flex-start;
  }
  .white-card{
    .white-card-header{
      justify-content: unset;
      .title-wrap {
        min-width: 300px;
        width: 60%;
        .title-label{
          text-transform: capitalize;
        }
      }
    }
  }
  .heading {
    border-bottom: 0 !important;
    align-items: center;
    margin: 0 78px 0 0;

    button.back-to {
      width: 40px;
      height: 40px;
      padding: 0;
      margin: 0 20px;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    button.edit-name {
      margin-left: 20px;
      padding: 0;
      width: 24px;
      height: 24px;

      i {
        font-size: 20px;
      }
    }
  }

  .role-heading {
    display: flex;
    width: 100%;
    height: 73px;
    background-color: $atto-grey;
    border-bottom: 1px solid $grey-nuance-lighter;
    align-items: center;
    padding: 0 20px;

    .add {
      display: flex;
      width: 40px;
      height: 40px;
      align-items: center;
      justify-content: center;
      margin-right: 20px;
      color: $atto-green;

      &:hover {
        color: $atto-dark-green;
      }
    }

    h4.subtitle {
      font-size: 16px;
      line-height: 24px;
    }

    &.members {
      border-top: 1px solid $grey-nuance-lighter;
    }
  }

  .list-container {
    .table-heading {
      border-top: none !important;
      /*border-bottom: 1px solid $atto-light-grey !important;*/
     /* padding: 12px 0 12px 64px;*/
      .label-holder{
        min-width: 544px;
        width: 60%;
        display: flex;

        .heading-label {
          &.name {
            min-width: 200px;
            width: 36%;
            margin-right: 10px;
          }
        }
      }
    }

    .team-members {
      li {
        padding: 7px 16px;
        height: 50px;
        border-bottom: none;
        &:hover {
          background-color: $atto-grey;
          color: $atto-font-color;
        }

        &.no-members {
          padding: 0;
          justify-content: center;

          &:hover {
            background-color: #fff;
          }
        }
        .member-info{
          min-width: 370px;
          width: 60%;
        }
        .pic-wrap{
          min-width: 36px;
          max-width: 36px;
          height: 36px;
          margin-right: 12px;
        }
      }

      .member-wrap {
        min-width: 200px;
        width: 35%;
        margin-right: 10px;
        .member-name{
          font: $roboto-regular 0.9375rem/1.5rem $roboto-font;
        }
      }

      .dep-wrap {
        min-width: 114px;
        margin-right: 16px;
        width: 35%;

        span.detailed-label {
          color: $atto-font-color;
          font: $roboto-regular 0.875rem/1rem $roboto-font;
        }
      }

      .switch-options {
        min-width: 150px;
        display: flex;
        justify-content: flex-start;

        button.switch-department {
          padding: 0;
          display: flex;
          align-items: center;
          font-size: 0.875rem;
          line-height: 1.5rem;
          color: $atto-not-active;
          font-family: $roboto-font;
          -webkit-transition: ease all 0.15s;
          -moz-transition: ease all 0.15s;
          -ms-transition: ease all 0.15s;
          -o-transition: ease all 0.15s;
          transition: ease all 0.15s;

          i {
            width: 24px;
            height: 24px;
            display: inline-flex;
            align-items: center;
            justify-content: center;
            font-size: 0.625rem;
            border-radius: 50%;
            background-color: transparent;
            /*background-image: url('~@assets/images/switch-arrow2.svg');*/
            -webkit-background-size: cover;
            background-size: cover;
            background-repeat: no-repeat;
            background-position: center;
            margin-right: 2px;
            -webkit-transition: ease all 0.15s;
            -moz-transition: ease all 0.15s;
            -ms-transition: ease all 0.15s;
            -o-transition: ease all 0.15s;
            transition: ease all 0.15s;
          }

          &:hover {
            color: $atto-font-color;

            i {

             /* background-image: url('~@assets/images/switch-arrow-active2.svg');*/
              &:before{
                background-color: $atto-green;
                width: 16px;
                height: 16px;
                border-radius: 50%;
                color: #ffffff;
                font-size: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
              }
            }
          }
        }

        &.delete {
          margin-right: 45px;
        }
      }

      &:last-child {
        li {

          &.no-members {
            margin-bottom: 0;
            border-bottom: 0;
          }
        }
      }
    }
  }

    .delete-log {
        .atto-delete {
            width: 40px;
            height: 40px;
            font-size: 18px;
            text-align: center;
            -webkit-box-align: center;
            align-items: center;
            -webkit-box-pack: center;
            justify-content: center;
            color: #C7C7C7;
            border-radius: 100%;
            -webkit-transition: ease all 0.15s;
            transition: ease all 0.15s;
            display: inline-flex;
        }

        &:hover {
            .atto-delete {
                background-color: #EFEFEF;
                color: #262626;
            }
        }
    }
    .content.settings-container.department-info {
        .heading button.edit-name{
            margin-right: auto;
        }
        .button-holder{
            border-bottom: 1px solid $atto-light-grey;
            height: 73px;
            display: flex;
            align-self: center;

            button{
                color: $atto-green;
                font-family: 'Roboto', sans-serif;
                font-weight: 500;
            }
        }
        .role-heading{
            padding: 0 20px 0 80px;
        }
        .list-container .team-members li > div.no-time-entry{
            height: 73px;
        }
    }

/*  .no-time-entry{
    &.managers{
      .entry-wrap {
        i{
          background: url('~@assets/images/add_managers_department.svg') no-repeat center;
        }
      }
    }
    &.members{
      .entry-wrap {
        i{
          background: url('~@assets/images/add_members_department.svg') no-repeat center;
        }
      }
    }
  }*/

</style>